import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken, getOAuthToken } from "@/utils/auth";
const qs = require("qs");

// axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
});
service.interceptors.request.use(
  async config => {
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    const token = getToken() || (await getOAuthToken());
    console.log("token", token);
    if (token) {
      config.headers["Authorization"] = token;
    }

    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    const code = res.data.code;
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res;
    }

    if (code == "-5" || res.data.error == "please login") {
      MessageBox.confirm(
        "The login status has expired. You can stay on this page or log in again",
        "System prompt",
        {
          confirmButtonText: "Login again",
          cancelButtonText: "cancel",
          type: "warning"
        }
      ).then(() => {
        store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    } else if (+code !== 0) {
      Notification.error({
        title: res.data.error
      });
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  error => {

    if (error.response.status == 401) {
      MessageBox.confirm(
        "The login status has expired. You can stay on this page or log in again",
        "System prompt"
      ).then(() => {
        store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    } else {
      if (error.message != "cancel") {
        Message({
          message: error,
          type: "error",
          duration: 5 * 1000
        });
        return Promise.reject(error);
      }
    }
  }
);

export default service;
